import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { InjectionData, MODAL_CONTENT_TOKEN } from '@ecs-services/modal/modal.helper';
import { TranslatePipe } from '@ngx-translate/core';
import { SewButton, SewMarkdown } from '@sew/ui-components-angular/standalone';

export interface SafetyHintDialogData {
    markdownContent: string;
}

@Component({
    selector: 'ecs-safety-hint-dialog',
    templateUrl: './safety-hint-dialog.component.html',
    styleUrls: ['./safety-hint-dialog.component.scss'],
    imports: [CommonModule, TranslatePipe, SewMarkdown, SewButton],
})
export class SafetyHintDialogComponent {
    public markdownContent: string;

    public constructor(
        @Inject(MODAL_CONTENT_TOKEN)
        private injection: InjectionData<SafetyHintDialogData, boolean>
    ) {
        this.markdownContent = injection.data?.markdownContent ?? '';
    }

    public confirm() {
        this.injection.close();
    }
}
